import classNames from "classnames";
import { Link } from "react-router-dom";
import { ROUTES } from "../../constant/common.constant";
import styles from "./TenantLogo.module.scss";
import { useTenant } from "../../context/Tenant";

export enum LOGO_SIZE_ENUM {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

interface Props {
  size?: LOGO_SIZE_ENUM;
  fullNameLogo?: boolean;
  className?: string;
}

export const TenantLogo = ({
  size = LOGO_SIZE_ENUM.SMALL,
  fullNameLogo = true,
  className,
}: Props) => {
  const { tenant } = useTenant();
  return (
    <Link to={ROUTES.HOME}>
      {fullNameLogo ? (
        <img
          src={tenant.logo.logo}
          alt={`${tenant.tenantName} logo`}
          className={classNames(styles.logo, styles[size], className)}
        />
      ) : (
        <img
          alt={`${tenant.tenantName} logomark`}
          src={tenant.logo.logomark}
          className={classNames(styles.logo, styles[size], className)}
        />
      )}
    </Link>
  );
};
